<script>
	import ColDefiner from './colDefiner.vue';
	import { Table } from 'element-ui';
	import * as macro from './macro';

	export default {
		inject: ['addEvent'],
		components: { ColDefiner },
		name: 'tableDefiner',
		props: {
			columns: {
				type: Array,
				require: true,
			},
			filter: {
				type: Function,
				default: () => true,
			},
			data: {
				type: Array,
				default: () => [],
			},
			bindLabel: {
				type: Function,
			},
			bindData: {
				type: Function,
			},
			bindDesc: {
				type: Function,
			},
		},
		data() {
			return {
				scope: {},
			};
		},
		render(h) {
			const flexProp = {};

			if (this.bindLabel) {
				flexProp.bindLabel = this.bindLabel;
			}
			if (this.bindData) {
				flexProp.bindData = this.bindData;
			}
			if (this.bindDesc) {
				flexProp.bindDesc = this.bindDesc;
			}

			//将插槽和默认处理组合为列表数组
			const slot = this.$slots.default || [];
			const columns = [];

			let i, j;
			//没有包含到this.columns中的列,按条目顺序添加到columns中
			//这里假定slot内指定的列是唯一且符合this.columns记录的
			//否则将出现错误
			for (i = 0, j = 0; i < this.columns.length; i++) {
				let refrenced = false;
				let macroFn = null;

				try {
					if (this.columns[i].macro) {
						macroFn = macro[this.columns[i].macro];
					} else {
						const lsh = this.columns[i].prop;
						const rsh = slot[j].componentOptions.propsData.col;
						refrenced = lsh === rsh;
					}
				} catch {}

				//追加判定是否要渲染,默认为渲染所有
				if (!this.filter(this.columns[i], refrenced)) {
					if (refrenced) {
						j++;
					}
					continue;
				}

				// 因为是预实现的代码,所以macro不能记为引用,同时又必须作为自定义列处理,这里保留代码冗余,只做一次if判断
				if (macroFn) {
					const comp = macroFn(this, h);

					Object.assign(comp.componentOptions.propsData, {
						desc: this.columns[i],
						...flexProp,
					});
					//注意这里有2个key字段,其中.data.key是无效的,.key才是真正的key属性
					comp.key = this.columns[i].prop;
					columns.push(comp);
				} else if (refrenced) {
					Object.assign(slot[j].componentOptions.propsData, {
						desc: this.columns[i],
						...flexProp,
					});
					//注意这里有2个key字段,其中.data.key是无效的,.key才是真正的key属性
					slot[j].key = this.columns[i].prop;
					columns.push(slot[j]);
					j++;
				} else {
					columns.push(<ColDefiner col="" props={{ ...flexProp }} desc={this.columns[i]} key={this.columns[i].prop}></ColDefiner>);
				}
			}

			let append = [];
			// 兼容append槽位简写,从还未判断过关系的子元素开始,碰到未预期的组件将其放到append槽位去
			for (; j < slot.length; j++) {
				if (slot[j].componentOptions === undefined || slot[j].componentOptions !== 'col-definer') {
					append.push(slot[j]);
				}
			}
			// 如果主动声明了append模板还是以此为准
			if (this.$slots.append instanceof Array) {
				append = this.$slots.append;
			}

			const eventListener = {};
			for (let key in this.$listeners) {
				const kebabCase = key.replace(/[A-Z]/g, (match) => {
					return '-' + match.toLowerCase();
				});
				eventListener[kebabCase] = this.$listeners[key];
			}
			eventListener['hook:mounted'] = this.childMount;
			return (
				<Table data={this.data} {...{ attrs: this.$attrs, on: eventListener, ref: 'table', class: this.$attrs.noScrollYSpace ? 'el-table--scrollable-y' : '' }}>
					{columns}
					<template slot="append">{append}</template>
				</Table>
			);
		},
		methods: {
			/*如果需要调用el-table的原生函数,请使用invoke委托调用 */
			invoke(method, ...param) {
				this.$refs.table[method](...param);
			},
			childMount() {
				setTimeout(() => {
					const el = this.$el;
					const th = el.querySelectorAll('tr th.is-leaf');
					th.item(th.length - 1).classList.add('c-is-last');
				}, 10);
			}
		},
		mounted(){
			/*
				noScrollYSpace属性：为true时，y轴的滚动条不占x轴方向上的空间，但仍能滚动(el-table--scrollable-y)
				注：不包括隐藏滚动条
			 */
			if(this.$attrs.noScrollYSpace){
				// 覆盖layout的updateScrollY函数
				this.$refs.table.layout.updateScrollY = function(){
					const height = this.height;
					// noScrollYSpace为true时，scrollY为false，渲染时不会给滚动条留空间
					if (height === null || this.table.$attrs.noScrollYSpace) return false;
					const bodyWrapper = this.table.bodyWrapper;
					if (this.table.$el && bodyWrapper) {
						const body = bodyWrapper.querySelector('.el-table__body');
						const prevScrollY = this.scrollY;
						const scrollY = body.offsetHeight > this.bodyHeight;
						this.scrollY = scrollY;
						return prevScrollY !== scrollY;
					}
					return false;
				}
			}
		},
	};
</script>
